import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { mediaManagerClient } from '@/lib/axios';
import { MutationConfig } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';
import { emptyStringValues } from '@/utils/objects';

import { TPostSegmentPeople, TSegmentPeople } from '../types';

export async function postSegmentPeople(body: TPostSegmentPeople): Promise<TSegmentPeople> {
  return mediaManagerClient
    .post('/api/v1/segment_people', emptyStringValues(body))
    .then(response => response as unknown as TSegmentPeople);
}

type MutationFn = typeof postSegmentPeople;

type TUsePostSegmentPeopleParams = {
  config?: MutationConfig<MutationFn>;
};

export function usePostSegmentPeople({ config }: TUsePostSegmentPeopleParams = {}) {
  const { t } = useTranslation();
  const { addErrorNotification, addSuccessNotification } = useNotificationStore();

  return useMutation({
    ...config,
    mutationFn: postSegmentPeople,
    onError(error) {
      addErrorNotification(t('No se ha podido crear la persona de interés del segmento'));
      console.error(error);
    },
    onSuccess() {
      addSuccessNotification(t('La persona de interés del segmento se ha creado correctamente'));
    },
  });
}
